// extracted by mini-css-extract-plugin
export var box = "_8c-1";
export var checked = "_8c-2";
export var descriptionSpacer = "_8c-9";
export var disabled = "_8c-3";
export var icon = "_8c-6";
export var input = "_8c-0";
export var labelSpacer = "_8c-8";
export var medium = "_8c-5";
export var small = "_8c-4";
export var text = "_8c-7";